import { useColorModeValue as mode, Text } from '@chakra-ui/react';
import classNames from 'classnames';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import styles from './field-group.module.css';

interface FieldGroupProps extends ComponentPropsWithoutRef<'div'> {
  title?: string;
  description?: string;
  /** Right-aligned action on the title row, e.g. a Reset link. */
  action?: ReactNode;
}

export const FieldGroup = (props: FieldGroupProps) => {
  const { title, description, action, className, ...boxProps } = props;
  return (
    <div>
      {description &&
        (action ? (
          <div className={styles.titleRow}>
            <Text className={styles.title} fontWeight="semibold">
              {title}
            </Text>
            {action}
          </div>
        ) : (
          <Text className={styles.title} fontWeight="semibold">
            {title}
          </Text>
        ))}
      {description && (
        <Text
          className={styles.description}
          color={mode('gray.600', 'gray.400')}
          fontSize="sm"
        >
          {description}
        </Text>
      )}
      <div
        className={classNames(styles.body, className)}
        data-has-header={title || description ? true : undefined}
        {...boxProps}
      />
    </div>
  );
};
